import axios, { type AxiosInstance } from 'axios';

// Axios instance with credentials. Dev server proxies /api to the
// API process (vite.config.ts). In production the same-origin
// nginx server block routes /api/* to the API.

const baseURL = import.meta.env.VITE_API_URL ?? '/api';

export const apiClient: AxiosInstance = axios.create({
  baseURL,
  withCredentials: true,
  // 401s aren't errors at the network level — they're signals
  // (auth required). AuthGuard handles them via React Query.
  validateStatus: (status) => status < 500,
});

export class AuthRequiredError extends Error {
  constructor() {
    super('Authentication required');
    this.name = 'AuthRequiredError';
  }
}
